// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.taskDeadline_number__TVKbk {
  font-weight: 800;
  font-size: 1.2rem;
}

.taskDeadline_letter__uycVu {
  font-size: 0.75rem;
  font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomTasksComponents/taskDeadline.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".number {\n  font-weight: 800;\n  font-size: 1.2rem;\n}\n\n.letter {\n  font-size: 0.75rem;\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"number": `taskDeadline_number__TVKbk`,
	"letter": `taskDeadline_letter__uycVu`
};
export default ___CSS_LOADER_EXPORT___;
